import React from 'react';
import { history } from 'state/store';
import styled from 'styled-components';
import { media } from 'utils/style';
import { Header } from './components/Header';
import { Cover } from './components/Cover';
import { Footer } from './components/Footer';
import { Contact } from './components/Contact';
import { LandingMain } from './pages/Main';
import { BackButton } from './components/BackButton';
import { LandingRegister } from './pages/LandingRegister';
import { LandingLogin } from './pages/LandingLogin';
import { LandingRecover } from './pages/LandingRecover';

const LandingRoot = styled.div`
  position: absolute;
  height: 100%;
  margin: 0;
  width: 100%;
`;

const LandingContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  margin: 0;
  ${media.lessThan('small')`
    flex-direction: column;
    overflow: auto !important;
    height: 200%;
  `};

  &.hidden-cover {
    ${media.lessThan('small')`
      height: 100% !important;
    `};

    #landing-cover {
      ${media.lessThan('small')`
        display: none !important;
      `};
    }
  }
`;

const LandingContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 50%;
  height: 100%;
  ${media.lessThan('small')`
    width: 100%;
  `};
`;

//Layout

const LandingLayout = ({
  children,
  showBackButton = false,
  hideCover = false,
}) => {
  return (
    <>
      <LandingRoot>
        <Header />
        <LandingContainer className={hideCover ? 'hidden-cover' : ''}>
          <Cover />
          <LandingContent id="landing-content">
            {showBackButton && (
              <BackButton
                onClick={() => {
                  history.goBack();
                }}
              />
            )}
            {children}
            <Contact />
          </LandingContent>
        </LandingContainer>
        <Footer />
      </LandingRoot>
    </>
  );
};

//Pages

export const LandingPage = () => {
  return (
    <LandingLayout>
      <LandingMain />
    </LandingLayout>
  );
};

export const LandingLoginPage = (props) => {
  console.log('🚀 ~ LandingLoginPage ~ props:', props);
  return (
    <LandingLayout showBackButton hideCover>
      <div>
        <LandingLogin {...props} />
      </div>
    </LandingLayout>
  );
};

export const LandingRecoverPasswordPage = (props) => {
  console.log('🚀 ~ LandingRecoverPasswordPageggg ~ props:', props);
  return (
    <LandingLayout showBackButton hideCover>
      <div>
        <LandingRecover {...props} />
      </div>
    </LandingLayout>
  );
};

export const LandingRegisterPage = (props) => {
  console.log('🚀 ~ LandingRegisterPage ~ props:', props);
  return (
    <LandingLayout showBackButton hideCover>
      <div>
        <LandingRegister {...props} />
      </div>
    </LandingLayout>
  );
};
